<template>
    <div>
        <HotLinkBlock class="component" />
        <SportListBlock class="component" />
        <ExtraBlock class="component" />
    </div>
</template>

<script lang="ts" setup>
    import ExtraBlock from '@/components/sportList/ExtraBlock.vue';
    import HotLinkBlock from '@/components/sportList/HotLinkBlock.Euro.vue';
    import SportListBlock from '@/components/sportList/SportListBlock.Euro.vue';
</script>

<style lang="scss" scoped>
    .component {
        :deep(.tabs_header) {
            height: auto;

            .tab_header_item:only-child {
                padding: var(--spacers-md);
                border-radius: var(--borderRadius-md) var(--borderRadius-md) 0 0;
                pointer-events: none;
            }
        }

        :deep(.tabs_content:last-child) {
            border-radius: 0 0 var(--borderRadius-md) var(--borderRadius-md);
        }
    }
</style>
